import React from 'react';
import { iconSizer } from "../../../../../icons2022/iconSizer";
import { DocTextIcon24Regular } from "../../../../../icons2022/FileTypeDocTextIcon/DocTextIcon24Regular";
import { DocTextIcon32Regular } from "../../../../../icons2022/FileTypeDocTextIcon/DocTextIcon32Regular";
import { DocTextIcon64Regular } from "../../../../../icons2022/FileTypeDocTextIcon/DocTextIcon64Regular";
export var DocTextIcon = iconSizer({
  small: function small() {
    return /*#__PURE__*/React.createElement(DocTextIcon24Regular, null);
  },
  medium: function medium() {
    return /*#__PURE__*/React.createElement(DocTextIcon32Regular, null);
  },
  large: function large() {
    return /*#__PURE__*/React.createElement(DocTextIcon64Regular, null);
  }
}, 'DocTextIcon');